module.exports = __webpack_public_path__ + "img/exc_2.0dfb72b6.webp";